export default "__VITE_ASSET__DOQEsl2L__"